'use client';

import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useState } from 'react';

import MoreSvg from '@/components/Icon/svgs/more.svg';
import SettingModal from '@/components/settingModal';
import type { IHomepageData } from '@/service/homePage';

import styles from './index.less';

interface IProps {
  className?: string;
  iconClassName?: string;
  homePageData?: IHomepageData | null;
}

const MoreIcon = (props: IProps): JSX.Element => {
  const { className, iconClassName, homePageData } = props;
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className={classNames(styles.buttonItem, className)}
        id="moreIcon"
        onClick={() => {
          setOpen(true);
        }}
      >
        <Icon className={classNames(styles.icon, iconClassName)} component={MoreSvg} />
      </div>

      <SettingModal
        avatar={homePageData?.avatar}
        blockedByMe={homePageData?.blockedByMe}
        friendStatus={homePageData?.friendStatus}
        handleClose={() => setOpen(false)}
        myAutoReply={homePageData?.autoReplySettings?.enableMyAIAutoReply}
        open={open}
        relationRemark={homePageData?.relationRemark}
        remark={homePageData?.remark}
        route={homePageData?.route}
        sessionId={homePageData?.sessionId}
        userId={homePageData?.userId}
        username={homePageData?.username}
      />
    </>
  );
};

export default MoreIcon;
